var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 59,
    viewBox: "0 0 49 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 17.1364H48.25V16.6219L47.8879 16.2565L47 17.1364ZM32 2L32.8879 1.12013L32.5211 0.75H32V2ZM31.9998 17.1364L30.7498 17.1363L30.7498 18.3864H31.9998V17.1364ZM17.0001 31.0227H15.7501V33.5227H17.0001V31.0227ZM32.0001 33.5227H33.2501V31.0227H32.0001V33.5227ZM17.0001 41.1137H15.7501V43.6137H17.0001V41.1137ZM27.0001 43.6137H28.2501V41.1137H27.0001V43.6137ZM47.8879 16.2565L32.8879 1.12013L31.1121 2.87987L46.1121 18.0162L47.8879 16.2565ZM32 0.75H7V3.25H32V0.75ZM7 0.75C3.5451 0.75 0.75 3.58685 0.75 7.04545H3.25C3.25 4.94618 4.94709 3.25 7 3.25V0.75ZM0.75 7.04545V52.4545H3.25V7.04545H0.75ZM0.75 52.4545C0.75 55.9132 3.5451 58.75 7 58.75V56.25C4.94709 56.25 3.25 54.5538 3.25 52.4545H0.75ZM7 58.75H42V56.25H7V58.75ZM42 58.75C45.4549 58.75 48.25 55.9132 48.25 52.4545H45.75C45.75 54.5538 44.0529 56.25 42 56.25V58.75ZM48.25 52.4545V17.1364H45.75V52.4545H48.25ZM30.75 1.99998L30.7498 17.1363L33.2498 17.1364L33.25 2.00002L30.75 1.99998ZM31.9998 18.3864H47V15.8864H31.9998V18.3864ZM17.0001 33.5227H32.0001V31.0227H17.0001V33.5227ZM17.0001 43.6137H27.0001V41.1137H17.0001V43.6137Z",
    fill: "#A5B3BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.450a9f7e8fce0c2b835cf5957860136c.svg";
export { ForwardRef as ReactComponent };